import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LookUpResourceModel } from '../../models/lookup-resource.model';
import { SectionModel } from '../../models/section.model';
import { SectionWiseService } from '../../service/section-wise.service';
import { SwProcessPageUiService } from '../../service/ui/sw-process-page-ui.service';
@Component({
  selector: 'swq-modal, [swqModal]',
  templateUrl: './swq-modal.component.html'
})
export class SWQModalComponent implements OnInit {
  question: LookUpResourceModel;
  sectionDetails: SectionModel;

  constructor(
    private activatedRoute: ActivatedRoute,
    public sectionWiseService: SectionWiseService,
    private swProcessPageUiService: SwProcessPageUiService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((param: any) => {
      if (param && param['question']) {
        this.question = JSON.parse(param['question']);
        if (this.question?.SectionName) {
          this.sectionDetails = this.sectionWiseService.sectionDetailsModel?.filter((f) => f.SectionName === this.question.SectionName)[0];
        }
      }
    });
  }

  discardSwqModal() {
    this.swProcessPageUiService.openSwDiscardModal({ isActive: true, isMainDiscard: false });
  }

  closeSwqModal() {
    this.sectionWiseService.closeSwqModal(new LookUpResourceModel());
  }
}
